import type { JSX } from 'react'

export const KidsProfileSolidIcon = (): JSX.Element => (
  <use href='#kidsProfileIcon' height='100%' width='100%' />
)
